import api from "../config";
import URLS from "../../constants/urls";
export const _getEventsBySiteID = async (siteId, pageNumber, pageSize) => {
    const response = await api.get(`${URLS.EVENT}/${siteId}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
    return response.data;
};
export const _createEvent = async (data) => {
    const response = await api.post(`${URLS.EVENT}/create`, data);
    return response.data;
};
export const _updateEvent = async (siteId, eventId, data) => {
    const response = await api.put(`${URLS.EVENT}/${siteId}/${eventId}`, data);
    return response.data;
};
export const _deleteEvent = async (siteId, eventId) => {
    const response = await api.delete(`${URLS.EVENT}/${siteId}/${eventId}`);
    return response.data;
};
export const _getCategoriesIcon = async () => {
    const response = await api.get(URLS.ICONS);
    return response?.data;
};
